import MOModalWrapper from "../../../../components/commons/MOModalWrapper";
import { ErrorMessage, Field, Form, Formik } from "formik";
import MOButtonV2 from "../../../../components/commons/MOButtonV2";
import { useState } from "react";
import { toastMessage } from "../../../../helpers/toastMessage";
import mobioApi from "../../../../services";
import { safeJsonParse } from "../../../../utils/safeJsonParse";

const EditSingleDocModal = ({
  modalOpen,
  setModalOpen,
  token,
  onboardingData,
  docData,
}) => {
  const handleSubmit = async (values, { setSubmitting }) => {
    setSubmitting(true);

    try {
      if (!values.file) {
        toastMessage("error", "Please upload image first");
        return;
      }
      if (
        !docData?.doc?.id &&
        !docData?.doc?.onboardingDocId &&
        !docData?.doc?.existingData &&
        !docData?.replacement
      ) {
        toastMessage("error", "Kindly refresh the hold page");
      }

      const formData = new FormData();
      formData.append("image", values.file);
      formData.append("replacement", docData.replacement);
      formData.append("onboardingDocId", docData?.doc?.onboardingDocId);
      formData.append("networkDocId", docData?.doc?.id);

      const api = mobioApi(token);
      const response = await api.onboardingDocImageInfoUpdate(formData);

      if (response?.data?.success) {
        onboardingData.onboardingDocs = onboardingData?.onboardingDocs?.map(
          (doc) => {
            if (docData?.doc?.onboardingDocId === doc?.id) {
              const previousData = safeJsonParse(doc.data);
              doc.data = JSON.stringify({
                ...previousData,
                [docData.replacement]: response?.data?.data,
              });
            }

            return doc;
          }
        );
      }

      toastMessage("success", response?.data?.msg);

      setModalOpen(false);
    } catch (error) {
      toastMessage("error", error?.response?.data?.msg);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <MOModalWrapper
      modalOpen={modalOpen}
      setModalOpen={setModalOpen}
      title={`Edit ${docData?.doc?.name}-(${docData?.replacement})`}
      className={"country-city-modal header-modal-section"}
    >
      <div>
        <Formik
          initialValues={{
            file: null,
            preview: null,
          }}
          onSubmit={handleSubmit}
        >
          {({ values, setFieldValue, isSubmitting }) => (
            <Form>
              {/* If doc type is Image → Show File Upload */}
              {/* {docData?.doc?.type === "Image" && (
                <div className="input-field-md-lg mb-20">
                  <p className="m-0 font-14 font-500 mb-10">Upload New Image</p>

               
                  <input
                    type="file"
                    accept="image/*"
                    onChange={(e) => {
                      const file = e.target.files[0];
                      if (file) {
                        setFieldValue("file", file);
                        setFieldValue("preview", URL.createObjectURL(file)); // preview image
                      }
                    }}
                  />

              
                  {values.preview && (
                    <div
                      style={{
                        position: "relative",
                        marginTop: "12px",
                        display: "inline-block",
                      }}
                    >
                      <img
                        src={values.preview}
                        alt="Preview"
                        style={{
                          width: "120px",
                          height: "120px",
                          borderRadius: "8px",
                          objectFit: "cover",
                          border: "1px solid #ccc",
                        }}
                      />

                  
                      <button
                        type="button"
                        onClick={() => {
                          setFieldValue("file", null);
                          setFieldValue("preview", null);
                        }}
                        style={{
                          position: "absolute",
                          top: "-8px",
                          right: "-8px",
                          backgroundColor: "#ff4d4f",
                          color: "#fff",
                          border: "none",
                          borderRadius: "50%",
                          width: "22px",
                          height: "22px",
                          fontSize: "12px",
                          cursor: "pointer",
                        }}
                      >
                        ×
                      </button>
                    </div>
                  )}
                </div>
              )} */}

              {docData?.doc?.type === "Image" && (
                <div className="input-field-md-lg mb-20">
                  <p className="m-0 font-14 font-500 mb-10">Upload New File</p>

                  {/* File Input */}
                  <input
                    type="file"
                    accept={
                      docData?.replacement === "file"
                        ? "image/*,application/pdf" // allow image + pdf
                        : "image/*" // only images
                    }
                    onChange={(e) => {
                      const file = e.target.files[0];
                      if (file) {
                        setFieldValue("file", file);

                        // If image → show preview
                        if (file.type.startsWith("image/")) {
                          setFieldValue("preview", URL.createObjectURL(file));
                        } else {
                          // PDF → no preview image
                          setFieldValue("preview", null);
                        }
                      }
                    }}
                  />

                  {/* Image Preview (ONLY for images) */}
                  {values.preview && (
                    <div
                      style={{
                        position: "relative",
                        marginTop: "12px",
                        display: "inline-block",
                      }}
                    >
                      <img
                        src={values.preview}
                        alt="Preview"
                        style={{
                          width: "120px",
                          height: "120px",
                          borderRadius: "8px",
                          objectFit: "cover",
                          border: "1px solid #ccc",
                        }}
                      />

                      {/* Remove Button */}
                      <button
                        type="button"
                        onClick={() => {
                          setFieldValue("file", null);
                          setFieldValue("preview", null);
                        }}
                        style={{
                          position: "absolute",
                          top: "-8px",
                          right: "-8px",
                          backgroundColor: "#ff4d4f",
                          color: "#fff",
                          border: "none",
                          borderRadius: "50%",
                          width: "22px",
                          height: "22px",
                          fontSize: "12px",
                          cursor: "pointer",
                        }}
                      >
                        ×
                      </button>
                    </div>
                  )}

                  {/* PDF File Name (If PDF Selected) */}
                  {values.file && values.file.type === "application/pdf" && (
                    <p className="mt-10 font-12">
                      PDF Selected: <strong>{values.file.name}</strong>
                    </p>
                  )}
                </div>
              )}

              {/* Submit Button */}
              <div className="mt-20">
                <MOButtonV2
                  text={"UPDATE DOCUMENT"}
                  type="submit"
                  textColor="#ffffff"
                  radius={4}
                  backgroundColor="#29AEE6"
                  height={44}
                  fontSize={11}
                  widthSize={"100%"}
                  padding={"16px 0px"}
                  disabled={isSubmitting}
                />
              </div>
            </Form>
          )}
        </Formik>
      </div>
    </MOModalWrapper>
  );
};

export default EditSingleDocModal;
